import { UIPlaceholder } from "@hellocarbo/lasagne";

export const PendingResource = () => (
  <div className="gap-sm border-grayscale-x-light p-lg flex flex-col rounded-lg border">
    <UIPlaceholder ready={false} type="line" step="2">
      loading
    </UIPlaceholder>
    <UIPlaceholder ready={false} type="paragraph" numberOfLines={3}>
      loading
    </UIPlaceholder>
    <UIPlaceholder ready={false} type="square">
      loading
    </UIPlaceholder>
  </div>
);

export const PendingResources = () => {
  return (
    <div className="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {Array(3)
        .fill(0)
        .map((_, index) => {
          return <PendingResource key={index} />;
        })}
    </div>
  );
};

export const PendingAllResources = () => {
  return (
    <div className="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {Array(15)
        .fill(0)
        .map((_, index) => {
          return <PendingResource key={index} />;
        })}
    </div>
  );
};
